import React from 'react';
import {capitalize} from 'lodash';
import {withCommas} from 'shared/utils';
import styles from './college-facts.module.scss';
import InfoTooltip from 'shared/components/info-tooltip';

interface Props {
  collegeCategory: 'Public' | 'Private';
  distanceMiles: number;
  yearlyNetPriceDollars: number;
}

const CollegeFacts = ({collegeCategory, distanceMiles, yearlyNetPriceDollars}: Props) => {
  const firstDividerShown = collegeCategory && (distanceMiles || yearlyNetPriceDollars);
  const secondDividerShown = distanceMiles && yearlyNetPriceDollars;

  return (
    <div className={styles.facts}>
      {collegeCategory && <span className={styles.fact}>{capitalize(collegeCategory)}</span>}
      {firstDividerShown && <span className={styles.factsDivider}>|</span>}
      {distanceMiles && (
        <span className={styles.fact}>
          <span className={styles.emphasizedFact}>{distanceMiles}</span> miles from you
        </span>
      )}
      {secondDividerShown && <span className={styles.factsDivider}>|</span>}
      {yearlyNetPriceDollars && (
        <span className={styles.fact}>
          <span className={styles.emphasizedFact} data-testid="college-facts">
            {`$${withCommas(Math.round(yearlyNetPriceDollars))}`}
          </span>
          /yr Est. Net Price
          <InfoTooltip>
            This is a general estimate. See the Cost and Financial Aid section on the college
            profile for more info on understanding your costs.
          </InfoTooltip>
        </span>
      )}
    </div>
  );
};

export default CollegeFacts;
